/*eslint-disable*/
import React, {
    useState,
    useContext,
    useEffect,
    useRef,
    createContext,
  } from 'react'
  import { SidePanelContext } from './Canvas'
  import {
    NodeModes,
    NodeT,
    TreeT,
    WebHookResponseT,
    NodeAddModeT,
    WebhookInitialState,
    WebhookAuthType,
    WebHookT,
    NodeMode,
    AppTriggerInitialState,
    WebhookTypeT,
    InputKey,
    ActionInitialState,
    NodeView,
    NodeEdit,
    InputFieldT,
    Tree,
    Nodes,
  } from './types'
  import produce from 'immer'
  import {
    automationAPIURLWithWorkspace,
    getJson,
    postJson,
    putJson,
    webHookAPIURLWithWorkspace,
  } from '@/common/utils/api-utils'
  import { Modal } from '@/common/components/Modal'
  import { Error } from '@/common/components/ErrorBoundary'
  import { CanvasRightPanel } from './CanvasRightPanel'
  import {
    AppTriggersIcon,
    ConditionPopupHeaderIcon,
    DeleteIcon,
    DownArrowCircle,
    DownarrowWithCircle,
    EyeCloseIcon,
    EyeOpenIcon,
    InfoIcon,
    NodeHoverMenuIcons,
    WebhookIcon,
    WidgetCopyIcon,
    ApptriggerIconNew,
    SuccessIcon,
  } from '@/common/Icons/Icons'
  import { makeDefaultInputKey } from './NoTriggerPanel'
  import styled from '@emotion/styled/macro'
  import { Loader } from '@/common/components/Loader'
  import {
    ActionPanelPopup,
    Button,
    ButtonContainer,
    EmptyDiv,
    InputContainer,
    InputContent,
    Input as InputBox, 
    InputWrapper,
    PopupContainer,
    PopupScrollHeight,
    PopupWrapper,
    Wrapper as ActionWrapper,
  } from '@/common/styled/Workflow.Dumb'
  import { VideoLink } from '@/Videos/Videos'
  import Tooltip from 'react-tooltip-lite';
  import { CancelButtonInput } from './ActionPanel'
import { ButtonWrapper } from '../AutomationMarketplaceDownload'
  
  export type WebHookPanelStateT = {
    show: boolean
    parentNode: TreeT<NodeT>
    mode: NodeModes
    currentNode: WebHookResponseT
  }
  
  export type WebHookPanelStateContextT = {
    webHookPanelState: WebHookPanelStateT
    setWebHookPanelState: (object: any) => void
  }
  
  export const WebHookPanelStateContext = createContext<
    WebHookPanelStateContextT
  >({
    webHookPanelState: {
      show: false,
      mode: NodeAddModeT,
      parentNode: { value: Tree, children: [] },
      currentNode: WebhookInitialState,
    },
    setWebHookPanelState: (object: any) => undefined,
  })
  
  export const WebhookPanel = (props: any) => {
    const { rightPanelState } = useContext(SidePanelContext)
  
    const [webHookPanelState, setWebHookPanelState] = useState({
      ...rightPanelState,
      currentNode: rightPanelState.currentNode as WebHookResponseT,
    })
  
    return (
      <WebHookPanelStateContext.Provider
        value={{
          webHookPanelState,
          setWebHookPanelState,
        }}
      >
        <ConditionActualComponent {...props} />
      </WebHookPanelStateContext.Provider>
    )
  }
  
  const ConditionActualComponent = (props: any) => {
    // for comparing props
    const ConditionElement = useRef<any>(null)
  
    const {
      rightPanelState,
      setRightPanelState,
      saveTree,
      treeData,
      setEditTreeData,
      editTreeData,
      active_automation,
    } = useContext(SidePanelContext)
    // const { api } = useContext(APIContext);
  
    const { webHookPanelState, setWebHookPanelState } = useContext(
      WebHookPanelStateContext,
    )
  
    const currentNode = webHookPanelState.currentNode as WebHookResponseT
  
    const [loading, setLoading] = useState(true)
    const [prevNodeAuth, setPrevNodeAuth] = useState({
      auth: WebhookAuthType.None,
    })
    const [showWarningModal, setShowWarningModal] = useState({
      show: false,
    })

    const [eyeOpened,toggleEyeOpen] = useState(false)

    const [showCopied,setShowCopied] = useState(false)

    const triggerMeta = currentNode.trigger.triggerMeta as WebHookT
  
    useEffect(() => {
      const currentMode = rightPanelState.mode
  
      // compare props and update changes based on following condition
      if (
        !ConditionElement.current ||
        (ConditionElement.current &&
          (rightPanelState.mode.mode !== ConditionElement.current.mode.mode ||
            (currentMode.mode === NodeMode.Edit &&
              currentMode.nodeEditInput.id !==
                ConditionElement.current.mode.nodeEditInput.id)))
      ) {
        if (
          currentMode.mode === NodeMode.Add ||
          currentMode.mode === NodeMode.Edit
        ) {
          // next time to compare with previous props
          ConditionElement.current = rightPanelState
  
          callAuthAPI(rightPanelState.currentNode as WebHookResponseT)
        } else {
          ConditionElement.current = rightPanelState
          currentMode.mode === NodeMode.Loading
            ? setLoading(true)
            : setLoading(false)
  
          setWebHookPanelState({
            ...rightPanelState,
            currentNode: rightPanelState.currentNode as WebHookResponseT,
          })
        }
      } else if (
        rightPanelState.mode.mode === NodeMode.Edit &&
        ConditionElement.current.mode.mode === NodeMode.Edit &&
        rightPanelState.mode.nodeEditInput.id ===
          ConditionElement.current.mode.nodeEditInput.id
      ) {
        setWebHookPanelState({
          ...webHookPanelState,
          show: true,
        })
      }
    }, [rightPanelState.mode])
    // to change ConditionElement.current values while updating state in each step
    useEffect(() => {
      ConditionElement.current = webHookPanelState
  
      // to see the details in left side panel while adding or editing
      setRightPanelState({
        ...rightPanelState,
        currentNode: webHookPanelState.currentNode,
      })
    }, [webHookPanelState.currentNode])
  
    function callAuthAPI(node: WebHookResponseT) {
      if (node.authentication.auth == WebhookAuthType.Basic) {
        getJson(
          webHookAPIURLWithWorkspace(
            props.match.params.workspacename,
            `/webhook/authentication/${node.authentication.authId}/retrieve/`,
            // props.api
          ),
        ).then((authResp) => {
          const nextValue = produce(node, (draftState) => {
            const auth = Object.assign(
              draftState.authentication as {
                auth: WebhookAuthType.Basic
                username: string
                password: string
                authId: string
              },
              {},
            )
            auth.username = authResp.output.auth_schema.username
            auth.password = authResp.output.auth_schema.password
  
            draftState.authentication = auth
          })
  
          setPrevNodeAuth(nextValue.authentication)
  
          setWebHookPanelState({
            ...rightPanelState,
            currentNode: nextValue,
          })
          setLoading(false)

        })
      } else {
        setWebHookPanelState({
          ...rightPanelState,
          currentNode: node,
        })
        setLoading(false)
      }
    }
  
    // disable or enable save button
    function enableSave() {
      return (
        currentNode.name.length > 0 && (currentNode.authentication.auth == WebhookAuthType.None
          ||
          (currentNode.authentication.username && 
            currentNode.authentication.password&&
            currentNode.authentication.username.length>0&&
            currentNode.authentication.password.length>0))
        // currentNode.name.length > 0 &&
        // (triggerMeta.inputKeys.length == 0 ||
        //   triggerMeta.inputKeys.filter(
        //     (inp) => inp.title.length == 0 && inp.type.length == 0,
        //   ).length == 0)
      )
    }
  
    function enableAddmore() {
      return (
        triggerMeta.inputKeys.length == 0 ||
        triggerMeta.inputKeys.filter(
          (inp) => inp.title.length > 0 && inp.type.length > 0,
        ).length > 0
      )
    }
  
    function notHaveDiff(
      prevNodeAuth:
        | {
            auth: WebhookAuthType.None
          }
        | {
            auth: WebhookAuthType.Basic
            username: string
            password: string
            authId: string
          },
      currNodeAuth: {
        auth: WebhookAuthType.Basic
        username: string
        password: string
      },
    ) {
      const auth = prevNodeAuth as {
        auth: WebhookAuthType.Basic
        username: string
        password: string
      }
  
      return (
        currNodeAuth.username == auth.username &&
        currNodeAuth.password == auth.password
      )
    }
  
    async function saveNode() {
      if (currentNode.authentication.auth == WebhookAuthType.Basic) {
        const auth = currentNode.authentication as {
          auth: WebhookAuthType.Basic
          username: string
          password: string
        }
        if (prevNodeAuth.auth == WebhookAuthType.None) {
          postJson(
            webHookAPIURLWithWorkspace(
              props.match.params.workspacename,
              '/webhook/authentication/create',
              //   props.api
            ),
          )({
            automationId: props.match.params.id,
            type: 'basic',
            auth_schema: {
              username: auth.username,
              password: auth.password,
            },
          }).then((resp) => {
          // Promise.resolve({data:{output:{id:""}}}).then((resp)=>{
            const nextValue = produce(currentNode, (draftState) => {
              const auth = Object.assign(
                draftState.authentication as {
                  auth: WebhookAuthType.Basic
                  username: string
                  password: string
                  authId: string
                },
                {},
              )
              auth.authId = resp.data.output.id
  
              draftState.authentication = auth
            })
  
            saveTree(nextValue)
          }).catch((err)=>{
            console.log(err)
          })
        } else if (notHaveDiff(prevNodeAuth as any, auth)) {
          console.log("hi2")

          saveTree(currentNode)
        } else {
          putJson(
            webHookAPIURLWithWorkspace(
              props.match.params.workspacename,
              '/webhook/authentication/update',
              //   props.api
            ),
          )()({
            id: currentNode.authentication.authId,
            type: 'basic',
            auth_schema: {
              username: auth.username,
              password: auth.password,
            },
          }).then((resp) => {
        // Promise.resolve({data:{output:{id:""}}}).then((resp)=>{
          const nextValue = produce(currentNode, (draftState) => {
              const auth = Object.assign(
                draftState.authentication as {
                  auth: WebhookAuthType.Basic
                  username: string
                  password: string
                  authId: string
                },
                {},
              )
              auth.authId = resp.data.output.id
  
              draftState.authentication = auth
            })
  
            saveTree(nextValue)
          }).catch((err)=>{
            console.log(err)
          })
        }
      } else {
        const nextValue = produce(currentNode, (draftState) => {
          draftState.authentication = { auth: WebhookAuthType.None }
        })

        if(prevNodeAuth.auth== WebhookAuthType.Basic){
          postJson(
            webHookAPIURLWithWorkspace(
              props.match.params.workspacename,
              `/webhook/authentication/delete/${(prevNodeAuth as any).authId}`,
            ),
          )({}).then((resp) => {
            saveTree(nextValue)
          }).catch((err)=>{
            console.log(err)
          })
        }else{
        saveTree(nextValue)
      }
      }
    }
  
    const renderWarningModal = () => {
      if (showWarningModal.show) {
        return (
          <Modal showPopupLoader={false}>
            <React.Fragment>
              <h2>Do you want to continue?</h2>
              <p>Changing the type will affect your workflow model.</p>
            </React.Fragment>
            <ButtonWrapper style={{marginTop: 5}}>
              <Button
                className="btn btn-primary variable_update"
                type="button"
                data-dismiss="modal"
                onClick={() => {
                  setRightPanelState({
                    ...rightPanelState,
                    show: true,
                    currentTrigger: 'application',
                    currentNode: AppTriggerInitialState,
                    mode: {
                      ...NodeEdit,
                      nodeEditInput: treeData.tree.value,
                    },
                  })
                }}
              >
                Yes
              </Button>
              <Button
                className="btn btn-success variable_update"
                type="button"
                data-dismiss="modal"
                onClick={() => {
                  setShowWarningModal({ show: false })
                }}
                // style={{background: '#fff', border: '1px solid rgb(185, 185, 185)', color: 'rgb(51, 51, 51)'}}
              >
                No
                </Button>
                </ButtonWrapper>
          </Modal>
        )
      } else return null
    }
  
    const SidePanelContextValue = useContext(SidePanelContext)
  
    // to show loading whenever mode changed
    if (loading) {
      return (
        <div className="automation_canvas_right">
          <Wrapper>
            <div className="webhook_loader">
              {/* {props.scope == "AUTOMATE" ? (
                <AutomateLoader />
              ) : ( */}
              <Loader.PopupLoader show={true} />
              {/* )} */}
            </div>
          </Wrapper>
        </div>
      )
    } else if (webHookPanelState.mode.mode === NodeMode.Error) {
      return (
        <div className="automation_canvas_right">
          <Wrapper>
            <div className="flow_canvas_popup_error">
              <Error.AddorEdit
                info={webHookPanelState.mode.error}
                onClick={() => {
                  // cancelCurrentPopup({
                  //   webHookPanelState,
                  //   SidePanelContext: SidePanelContextValue,
                  // });
                }}
              />
            </div>
          </Wrapper>
        </div>
      )
    }
  
    const isErrorHandlingCondition =
      rightPanelState.mode.mode == NodeMode.Edit
        ? SidePanelContextValue.active_automation ||
          rightPanelState.parentNode.value.kind == 'ErrorHandlingCondition'
        : false
  
    const url =
      currentNode.name.length > 0
        ? window.location.origin +
          '/webhooks/external/' +
          props.match.params.id +
          '/' +
          currentNode.name.toLowerCase().replace(/ /g, '-')
        : ''
  
    const ActionTip = () => (
      <>
        <p>
          Use{' '}
          <a
            className="sidepanel_href_color"
            target="_blank"
            href="https://help.workativ.com/knowledgebase/creating-an-automation/"
          >
            Action
          </a>{' '}
          to perform a task or action in your app. You can create single or
          multiple actions in a workflow. The actions will be executed one by one
          provided previous action is successfully executed. Workflow will stop
          continuing to next step if an action fails.
        </p>
        <p>
          Tip: You can enable error handling if you want the workflow to execute
          next step even though the action is failed. Not recommended, if your bot
          depends on the result of the workflow.
        </p>
      </>
    )
  
    return (
      <React.Fragment>
        {renderWarningModal()}
        {/* <div
          className={
            props.app_trigger
              ? "automation_canvas_right webhook_popup"
              : "action_popup"
          }
        > */}
        <Wrapper>
          <CanvasRightPanel.StepHeader
            title={
              !treeData.tree.value.meta_data
                ? 'Start your app workflow'
                : 'Edit your app workflow'
            }
            description={
              !treeData.tree.value.meta_data
                ? 'Set trigger.'
                : 'Edit trigger.'
            }
            infocontent={"Create workflows as webhooks. A workflow is triggered by a webhook call from a 3rd party endpoint (a chatbot or an app integration point). e.g When a chatbot needs to reset a user password in Okta."}
            helpcontent="Help document"
            helplink="https://help.workativ.com/knowledgebase/webhook-trigger/"
          >
            {/* {currentNode.selectedApp.type == 'on_prem' ? (
                        <VideoLink id={'SECURELY_CONNECT_AN_ON_PREM_APP_IN_A_WORKFLOW'} text={'How to set triggers'} />
                    ) : (
                        <VideoLink id={'CREATE_AN_ACTION_IN_APP_WORKFLOW'} text={'How to set triggers'} />
                    )} */}
          </CanvasRightPanel.StepHeader>
          <PopupScrollHeight>
            <EmptyDiv>
              <div className="automation_canvas_right action_popup automation_apptrigger_popup">
                <InputWrapper className="automation_connection">
                  <div className="select_application">
                    <div className="select_work_form">
                      <h4>{'Select a starting point'}</h4>
                      <InputContainer>
                      <CanvasRightPanel.AppsDropDown
                        inputs={{
                          inputs: [
                            {
                              name: 'Application Trigger',
                              value: 'application',
                              icon: ApptriggerIconNew,
                            },
                            {
                              name: 'Triggered by Webhook',
                              value: 'webhook',
                              icon: WebhookIcon,
                            },
                          ],
                          key: 'name',
                          idKey: 'value',
                          showIcon: true,
                        }}
                        addDropDown
                        updateSelection={(
                          selectedOperatorValue: 'application' | 'webhook',
                          id: string,
                        ) => {
                          if(id == 'application' && treeData.tree.value.meta_data) {
                            setShowWarningModal({ show: true }) 
                          }else if(id == 'application'){
                            const newTree = editTreeData.tree;
                            
                            setRightPanelState({
                              ...rightPanelState,
                              show: true,
                              currentTrigger: 'application',
                              currentNode: AppTriggerInitialState,
                              mode: {
                                ...NodeEdit,
                                nodeEditInput: {
                                  ...Tree,
                                  id: newTree.value.id,
                                  name: 'Triggered by Application',
                                  kind: 'EventTrigger',
                                  output: { properties: {} },
                                  icon: AppTriggersIcon
                                },
                              },
                            })
                            // this should happen after previous statement in the next tick that's why put timeout
                            setTimeout(()=>
                              setEditTreeData({
                                ...editTreeData,
                                tree: {
                                  ...newTree,
                                  value: {
                                    ...Tree,
                                    id: newTree.value.id,
                                    name: 'Triggered by Application',
                                    kind: 'EventTrigger',
                                    output: { properties: {} },
                                    icon: AppTriggersIcon
                                  },
                                },
                              })
                            )
                          }
                        }}
                        render={(makeDropDownVisible: () => void) => (
                          <React.Fragment>
                            <InputBox
                              type="text"
                              value={'Triggered by Webhook'}
                              onClick={makeDropDownVisible}
                              onChange={() => {}}
                              style={{ paddingLeft: 35, color: 'transparent', textShadow: '0 0 0 #000' }}
                              className={!active_automation?"":"editor_btn_disabled"}
                            />
                            <InputContent>Select trigger type</InputContent>
                            
                              <CancelButtonInput rotate onClick={makeDropDownVisible}>
                                <DownarrowWithCircle />
                              </CancelButtonInput>
  
                            <div className="input_img_left">
                              <img src={WebhookIcon} />
                            </div>
                          </React.Fragment>
                        )}
                      />
                      </InputContainer>
                    </div>
                  </div>
                </InputWrapper>
  
                <InputWrapper>
                  <InputContainer>
                    <InputBox
                      showHeader
                      disabled={isErrorHandlingCondition}
                      className={!active_automation?"":"editor_btn_disabled"}
                      onChange={(val) => {
                        const nextState = produce(
                          webHookPanelState.currentNode,
                          (draftState) => {
                            draftState.name = val.target.value
                          },
                        )
                        setWebHookPanelState({
                          ...webHookPanelState,
                          currentNode: nextState,
                        })
                      }}
                      value={webHookPanelState.currentNode.name}
                      onFocus={(val) => {}}
                      isErrorHandlingCondition={isErrorHandlingCondition}
                      input={
                        {
                          config: { kind: 'text' },
                          value: '',
                          description:
                            'Provide a name to identify your condition',
                          displayTitle: 'Name your webhook',
                          key: 'condition_name_key',
                          required: true,
                        } as InputFieldT
                      }
                      render={() => {}}
                    />
                      <InputContent>
                        Name your webhook{' '}
                        {/* <Tooltip
                            className="target customTip _description"
                            zIndex={10000}
                            tagName="span"
                            content="Provide a name to identify your condition"
                            distance={15}
                            forceDirection={true}
                            direction="up-start"
                        >
                            <InfoIcon />
                        </Tooltip> */}
                    </InputContent>
                  </InputContainer>
                  <InputContainer>
                    {/* <div className="automation_form_req automation_form_req_step_two"> */}
                    {/* <h4> */}
                      {/* Webhook URL:<span> (Required)</span> */}
                      {/* <label
                        className="copy_content"
                        onClick={() => {
                          var copyText = document.getElementById('myInput')
                          if (copyText) {
                            const el = copyText as HTMLInputElement
                            el.select()
                            el.setSelectionRange(0, 99999)
                            document.execCommand('copy')
                          }
                        }}
                      >
                         <NodeHoverMenuIcons.CopyIcon />
                        copy 
                      </label> */}
                    {/* </h4> */}
                    <div className="form_req_step_two_global_form input_ellipsis">
                      <div className={!active_automation && webHookPanelState.currentNode.name.length>0?"automation_global_form_edit automate":"automation_global_form_edit automate editor_btn_disabled"}>
                        <InputBox
                          type="text"
                          className="button_auto_input condition_name"
                          value={url}
                          id="myInput"
                          onChange={() => {}}
                        />
                        
                          <CancelButtonInput  
                          onClick={() => {
                          var copyText = document.getElementById('myInput')
                          if (copyText) {
                            const el = copyText as HTMLInputElement
                            el.select()
                            el.setSelectionRange(0, 99999)
                            document.execCommand('copy')
                            setShowCopied(true)
                            setTimeout(()=>{
                              setShowCopied(false)
                              el.blur()
                            },1000)
                          }
                        }}>
                          {showCopied &&
                            <span className="copy_function_copied">
                                <SuccessIcon />
                                <p>Copied</p>
                            </span>
                            }
                              <WidgetCopyIcon />
                            </CancelButtonInput>
                            <InputContent>
                              Webhook URL{' '}
                              <Tooltip
                                  className="target customTip _description"
                                  zIndex={10000}
                                  tagName="span"
                                  content="URL will be auto-generated once you name the webhook"
                                  distance={15}
                                  forceDirection={true}
                                  direction="up-start"
                              >
                                  <InfoIcon />
                              </Tooltip>
                        </InputContent>
                      </div>
                    </div>
                    {/* <p>
                      Copy and paste this URL in your app to call this workflow.
                      This webhook will be called when an event is triggered from
                      your app.
                    </p> */}
                  {/* </div> */}
                  </InputContainer>
                  
                  <div className="automation_form_req automation_form_req_step_two">
                    <div className="automation_condition_form">
                      <div className="select_application">
                        <div className="select_work_form">
                          <InputContainer>
                          <CanvasRightPanel.AppsDropDown
                            inputs={{
                              inputs: [
                                { name: 'None', value: 'None' },
                                { name: 'Basic', value: 'Basic' },
                              ],
                              key: 'name',
                              idKey: 'value',
                              showIcon: false,
                            }}
                            addDropDown
                            updateSelection={(
                              selectedOperatorValue: WebhookAuthType,
                              id: string,
                            ) => {
                              const nextValue = produce(
                                currentNode,
                                (draftState) => {
                                  draftState.authentication.auth = selectedOperatorValue
                                },
                              )
  
                              setWebHookPanelState({
                                ...webHookPanelState,
                                currentNode: nextValue,
                              })
                            }}
                            render={(makeDropDownVisible: () => void) => (
                              <React.Fragment>
                                {/* <h4>{'Authentication'}</h4> */}
                                <InputBox
                                  type="text"
                                  value={currentNode.authentication.auth}
                                  onClick={makeDropDownVisible}
                                  onChange={() => {}}
                                  style={{ paddingLeft: 10, color: 'transparent', textShadow: '0 0 0 #000' }}
                                  className={!active_automation?"":"editor_btn_disabled"}
                                />
  
                                {/* <div
                                  className="arrow_up_form"
                                  onClick={makeDropDownVisible}
                                >
                                  <DownArrowCircle />
                                </div> */}
                                <CancelButtonInput rotate onClick={makeDropDownVisible}>
                                  <DownarrowWithCircle />
                                </CancelButtonInput>
                              </React.Fragment>
                            )}
                          />
                          <InputContent> Select authentication type </InputContent>
                          </InputContainer>
                          {/* <p>Select the authentication method for the webhook.</p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                
                
                  {currentNode.authentication.auth == WebhookAuthType.Basic && (
                    <>
                      <div className="automation_global_form authentication_type">
                        <div className="select_work_form">
                          <InputContainer>
                          {/* <h4>{'Username: '}</h4> */}
                          <InputBox
                            type="text"
                            // className={`form_req_step_two_global_form`}
                            className={`form_req_step_two_global_form ${
                              active_automation ? "disabled_with_blue" : ""
                            }`}
                            value={currentNode.authentication.username}
                            onClick={() => {}}
                            onChange={(e) => {
                              const nextValue = produce(
                                currentNode,
                                (draftState) => {
                                  const auth = Object.assign(
                                    draftState.authentication as {
                                      auth: WebhookAuthType.Basic
                                      username: string
                                      password: string
                                      authId: string
                                    },
                                    {},
                                  )
    
                                  auth.username = e.target.value
                                  draftState.authentication = auth
                                },
                              )
    
                              setWebHookPanelState({
                                ...webHookPanelState,
                                currentNode: nextValue,
                              })
                            }}
                          />
                          {/* <p>Provide username.</p> */}
                          <InputContent>Username</InputContent>
                          </InputContainer>
                        </div>
                      </div>
                      <div className="automation_global_form">
                        <div className="select_work_form">
                          <InputContainer>
                          {/* <h4>{'Password: '}</h4> */}
                          <InputBox
                            type={eyeOpened?"text":"password"}
                            // className={`form_req_step_two_global_form`}
                            className={`form_req_step_two_global_form ${
                              active_automation ? "disabled_with_blue" : ""
                            }`}
                            value={currentNode.authentication.password}
                            onClick={() => {}}
                            onChange={(e) => {
                              const nextValue = produce(
                                currentNode,
                                (draftState) => {
                                  const auth = Object.assign(
                                    draftState.authentication as {
                                      auth: WebhookAuthType.Basic
                                      username: string
                                      password: string
                                      authId: string
                                    },
                                    {},
                                  )
                                  auth.password = e.target.value
                                  draftState.authentication = auth
                                },
                              )
    
                              setWebHookPanelState({
                                ...webHookPanelState,
                                currentNode: nextValue,
                              })
                            }}
                          />
                          {/* <p>Provide password.</p> */}
                          <InputContent>Password</InputContent>
                          <CancelButtonInput onClick={()=>toggleEyeOpen(!eyeOpened)}>
                            {eyeOpened?<EyeOpenIcon/>: <EyeCloseIcon />}
                          </CancelButtonInput>
                          </InputContainer>
                        </div>
                      </div>
                    </>
                  )}
                  <InputContainer style={{marginTop: 20}}>
              {/* <div className="connection_new_autoamtion">
                <div className="automation_condition_form"> */}
                  <div className="select_application">
                    <div className="select_work_form">
                      
                      <CanvasRightPanel.AppsDropDown
                        inputs={{
                          inputs: [
                            { name: 'POST', value: 'POST' },
                            { name: 'GET', value: 'GET' },
                          ],
                          key: 'name',
                          idKey: 'value',
                          showIcon: false,
                        }}
                        addDropDown
                        updateSelection={(
                          selectedOperatorValue: WebhookTypeT,
                          id: string,
                        ) => {
                          const nextValue = produce(currentNode, (draftState) => {
                            draftState.webhookType = selectedOperatorValue
                          })
  
                          setWebHookPanelState({
                            ...webHookPanelState,
                            currentNode: nextValue,
                          })
                        }}
                        render={(makeDropDownVisible: () => void) => (
                          <React.Fragment>
                            <InputBox
                              type="text"
                              value={currentNode.webhookType}
                              onClick={makeDropDownVisible}
                              onChange={() => {}}
                              style={{ paddingLeft: 10, color: 'transparent', textShadow: '0 0 0 #000' }}
                              className={!active_automation?"":"editor_btn_disabled"}
                            />
  
                            {/* <div
                              className="arrow_up_form"
                              onClick={makeDropDownVisible}
                            >
                              
                              <DownArrowCircle />
                            </div> */}
                            <InputContent>Select webhook type</InputContent>
                            <CancelButtonInput rotate onClick={makeDropDownVisible}>
                                <DownarrowWithCircle />
                              </CancelButtonInput>
                          </React.Fragment>
                        )}
                      />
                      {/* <p>Select a condition from the dropdown.</p> */}
                      
                      
                    {/* </div>
                  </div> */}
                </div>
              </div>
              </InputContainer>
                </InputWrapper>  
              </div>
              
              {/* {triggerMeta.inputKeys.map((inp, index) => (
                <div className="test_buton_result" key={index}>
                  <div className="test_buton_view">
                    <h6>Input Fields</h6>
                    <p>Input fields required to execute this webhook.</p>
                    <div className="icons_update">
                      <span
                        onClick={() => {
                          const nextValue = produce(currentNode, (draftState) => {
                            draftState.trigger.triggerMeta = {
                              ...triggerMeta,
                              inputKeys: triggerMeta.inputKeys.filter(
                                (i) => i.uniqueKey != inp.uniqueKey,
                              ),
                            }
                          })
  
                          setWebHookPanelState({
                            ...webHookPanelState,
                            currentNode: nextValue,
                          })
                        }}
                      >
                        <DeleteIcon />
                      </span>
                      <span>
                        <EditIcon />
                      </span>
                    </div>
                    <div className="select_application">
                      <div className="select_work_form">
                        <h4>{'Data type: '}</h4>
                        <CanvasRightPanel.AppsDropDown
                          inputs={{
                            inputs: [
                              { name: 'String', value: 'String' },
                              { name: 'Number', value: 'Number' },
                              { name: 'Boolean', value: 'Boolean' },
                            ],
                            key: 'name',
                            idKey: 'value',
                            showIcon: false,
                          }}
                          addDropDown
                          updateSelection={(dataType: any) => {
                            const nextValue = produce(
                              currentNode,
                              (draftState) => {
                                draftState.trigger.triggerMeta = {
                                  ...triggerMeta,
                                  inputKeys: triggerMeta.inputKeys.map(
                                    (i, ind) => {
                                      if (i.uniqueKey == inp.uniqueKey) {
                                        return { ...i, type: dataType }
                                      }
                                      return i
                                    },
                                  ),
                                }
                              },
                            )
  
                            setWebHookPanelState({
                              ...webHookPanelState,
                              currentNode: nextValue,
                            })
                          }}
                          render={(makeDropDownVisible: () => void) => (
                            <React.Fragment>
                              <input
                                type="text"
                                value={inp.type}
                                onClick={makeDropDownVisible}
                                onChange={() => {}}
                                style={{ paddingLeft: 10 }}
                                // className={"disabled_with_blue without_caret_input"}
                              />
  
                              <div
                                className="arrow_up_form"
                                onClick={makeDropDownVisible}
                              >
                                <DownArrowCircle />
                              </div>
                            </React.Fragment>
                          )}
                        />
                        <p>Select a condition from the dropdown.</p>
                      </div>
                    </div>
                    <div className="automation_form_req automation_form_req_step_two">
                      <div className="automation_global_form">
                        <div className="select_work_form">
                          <h4>{'Field name: '}</h4>
                          <input
                            type="text"
                            className={`form_req_step_two_global_form`}
                            // className={`without_caret_input form_req_step_two_global_form input_selected ${
                            //   active_automation ? "disabled_with_blue" : ""
                            // }`}
                            value={inp.title}
                            onClick={() => {}}
                            onChange={(e) => {
                              const nextValue = produce(
                                currentNode,
                                (draftState) => {
                                  draftState.trigger.triggerMeta = {
                                    ...triggerMeta,
                                    inputKeys: triggerMeta.inputKeys.map(
                                      (i, _ind) => {
                                        if (i.uniqueKey == inp.uniqueKey) {
                                          return { ...i, title: e.target.value }
                                        }
                                        return i
                                      },
                                    ),
                                  }
                                },
                              )
  
                              setWebHookPanelState({
                                ...webHookPanelState,
                                currentNode: nextValue,
                              })
                            }}
                          />
                        </div>
                      </div>
                    </div>
  
                    <div className="automation_form_req automation_form_req_step_two">
                      <div className="automation_global_form">
                        <div className="select_work_form">
                          <h4 className="checkbox_width">
                            {'Optional:'} 
                            <span>
                              <CheckBoxWrapper>
                                <CheckBox
                                  id={'checkbox' + index}
                                  type="checkbox"
                                  checked={inp.optional}
                                  onChange={() => {}}
                                  onClick={(_e) => {
                                    const nextValue = produce(
                                      currentNode,
                                      (draftState) => {
                                        draftState.trigger.triggerMeta = {
                                          ...triggerMeta,
                                          inputKeys: triggerMeta.inputKeys.map(
                                            (i, _ind) => {
                                              if (i.uniqueKey == inp.uniqueKey) {
                                                return {
                                                  ...i,
                                                  optional: !inp.optional,
                                                }
                                              }
                                              return i
                                            },
                                          ),
                                        }
                                      },
                                    )
  
                                    setWebHookPanelState({
                                      ...webHookPanelState,
                                      currentNode: nextValue,
                                    })
                                  }}
                                />
                                <CheckBoxLabel htmlFor={'checkbox' + index} />
                              </CheckBoxWrapper>
                            </span>{' '}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}
  
              {/* <div
                className={
                  enableAddmore()
                    ? 'add_connection_automation'
                    : 'editor_btn_disabled add_connection_automation'
                }
                style={{ height: 80 }}
              >
                <div className=" show_options">
                  <h5
                    onClick={() => {
                      const newKey = makeDefaultInputKey()
  
                      const newRule = produce(currentNode, (draftState) => {
                        draftState.trigger.triggerMeta = {
                          ...triggerMeta,
                          inputKeys: [
                            ...triggerMeta.inputKeys,
                            {
                              ...newKey,
                              optional: false,
                            },
                          ] as (InputKey & { optional: boolean })[],
                        }
                      })
  
                      setWebHookPanelState({
                        ...webHookPanelState,
                        currentNode: newRule,
                      })
                    }}
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16.24 16.24"
                      >
                        <title>add input</title>
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Layer_1-2" data-name="Layer 1">
                            <path d="M0,8.12a.93.93,0,0,1,.93-.93H7.19V.93a.93.93,0,0,1,1.86,0V7.19h6.26a.93.93,0,0,1,0,1.86H9.05v6.26a.93.93,0,0,1-1.86,0V9.05H.93A.93.93,0,0,1,0,8.12Z" />
                          </g>
                        </g>
                      </svg>
                    </span>
                    Add Input
                  </h5>
                </div>
              </div> */}
            </EmptyDiv>
  
            <ButtonContainer className="footer_button_fixed">
              <Button
                className="automation_condition_button_btn"
                onClick={() => {
                  setRightPanelState({
                    ...rightPanelState,
                    show: false,
                    mode: NodeView,
                    parentNode: { value: Tree, children: [] },
                    currentTrigger: 'application',
                    // to set first step done in left side panel while cancel
                    currentNode: AppTriggerInitialState,
                  })
  
                  setTimeout(()=> setEditTreeData(treeData))
                }}
              >
                Cancel
              </Button>
              {!active_automation && (
                <Button
                  className={
                    enableSave()
                      ? 'automation_condition_button_btn'
                      : 'automation_condition_button_btn editor_btn_disabled'
                  }
                  disabled={!enableSave()}
                  onClick={() => saveNode()}
                >
                  Save
                </Button>
              )}
            </ButtonContainer>
          </PopupScrollHeight>
        </Wrapper>
      </React.Fragment>
    )
  }
  
  const Wrapper = (props: any) => (
    // <div className="automation_canvas_right_popup webhook_right_popup">
    //   <div className="automation_rightside_form automation_rightside_step_two edit_action_height ">
    //     <div className="automation_rightside_form automation_rightside_step_two">
    //       {props.children}
    //     </div>
    //   </div>
    // </div>
  
    <ActionWrapper>
      <ActionPanelPopup>
        <PopupWrapper>
          <PopupContainer>
            <div className="automation_canvas_right_popup automate">
              <div className="automation_canvas_right_popup_form">
                <div className="automation_rightside_form automation_rightside_step_two edit_action_height">
                  {props.children}
                </div>
              </div>
            </div>
          </PopupContainer>
        </PopupWrapper>
      </ActionPanelPopup>
    </ActionWrapper>
  )
  
  WebhookPanel.Header = (props: any) => {
    return (
      <div className="automation_form_header">
        <div className="automation_form_header_condition">
          <span className="condition_properties_width">
            <ConditionPopupHeaderIcon />
          </span>
          <h4>Condition</h4>
        </div>
        <p>
          Conditions to check before moving on to next action in the workflow.
        </p>
      </div>
    )
  }
  
  function Input(props: {
    input: {
      description: string
      displayTitle: string
      required: boolean
      key: string
    }
    showHeader: boolean
    value: string
    onChange: (e: string) => void
    onFocus: (key: string) => void
    disabled: boolean
    render: any
    onKeyDown?: (e: React.KeyboardEvent) => void
    isErrorHandlingCondition?: boolean
  }) {
    const {
      input,
      onChange,
      onFocus,
      value,
      disabled,
      render,
      onKeyDown,
      isErrorHandlingCondition,
    } = props
  
    return (
      <div className={'automation_form_req automation_form_req_step_two'}>
        {props.showHeader && (
          <h4>
            {input.displayTitle}
            {!isErrorHandlingCondition &&
              (input.required ? (
                <span> (Required)</span>
              ) : (
                <span> (optional)</span>
              ))}
          </h4>
        )}
        <div
          className={
            disabled
              ? 'disabled_with_blue form_req_step_two_global_form'
              : 'form_req_step_two_global_form'
          }
        >
          <div className="automation_global_form_edit">
            {render()}
  
            <InputBox
              type="text"
              className={
                input.key == 'condition_name_key'
                  ? 'button_auto_input condition_name'
                  : 'button_auto_input'
              }
              value={value}
              onFocus={() => {
                onFocus(input.key)
              }}
              onChange={(e) => {
                onChange(e.target.value)
              }}
              onKeyDown={(e) => (onKeyDown ? onKeyDown(e) : {})}
            />
          </div>
        </div>
        <p>{input.description}</p>
      </div>
    )
  }
  
  const CheckBoxWrapper = styled.div`
    position: relative;
  `
  const CheckBoxLabel = styled.label`
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
    border: 0.5px solid #cecece;
    cursor: pointer;
    width: 30px;
    height: 18px;
    cursor: pointer;
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      margin: 2px;
      background: #b9b9b9;
      transition: 0.2s;
    }
  `
  const CheckBox = styled.input`
    opacity: 0;
    z-index: 1;
    border-radius: 15px;
    width: 30px;
    height: 18px;
    &:checked + ${CheckBoxLabel} {
      background: #fff;
      border: 0.5px solid #0c933e;
      &::after {
        content: '';
        display: block;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        margin-left: 14px;
        transition: 0.2s;
        background: #0c933e;
        border: 0.5px solid #0c933e;
      }
    }
  `
  